var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.hidden ? "div" : "th",
    _vm._g(
      {
        tag: "component",
        class: { sort: _vm.sort, sorted: _vm.active },
        attrs: { "aria-hidden": _vm.hidden },
      },
      _vm._on
    ),
    [
      _vm.show && _vm.sort && _vm.numeric && !_vm.rtl
        ? _c(
            "span",
            { staticClass: "_tha" },
            [
              _vm.dir > 0
                ? [
                    _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                      _c("path", { attrs: { d: "M18 15l-6-7-6 7z" } }),
                    ]),
                  ]
                : [
                    _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                      _c("path", { attrs: { d: "M6 9l6 7 6-7z" } }),
                    ]),
                  ],
              _vm._v(" "),
            ],
            2
          )
        : _vm._e(),
      _vm.show
        ? _c("span", { staticClass: "_thc" }, [_vm._t("default")], 2)
        : _vm._e(),
      _vm.show && _vm.sort && (!_vm.numeric || _vm.rtl)
        ? _c(
            "span",
            { staticClass: "_tha" },
            [
              _vm._v(" "),
              _vm.dir > 0
                ? [
                    _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                      _c("path", { attrs: { d: "M18 15l-6-7-6 7z" } }),
                    ]),
                  ]
                : [
                    _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                      _c("path", { attrs: { d: "M6 9l6 7 6-7z" } }),
                    ]),
                  ],
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }